import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";
import { PaginationMeta } from "./doctor";

export const getAllEmployees = async (tenant_id: number) => {
    const response = await api.get(`${API_ROUTES.EMPLOYEE}/list/${tenant_id}`);
    return response.data.data;
}

export interface EmployeeServerFilters {
    search?: string;
    work_type?: string;
    zone_id?: number;
    head_quarter_id?: number;
    designation_id?: number;
}

export const getEmployeesPaginated = async (
    tenant_id: number,
    page: number = 1,
    per_page: number = 15,
    filters: EmployeeServerFilters = {}
): Promise<{ data: any[]; pagination: PaginationMeta }> => {
    const response = await api.get(`${API_ROUTES.EMPLOYEE}/list/${tenant_id}`, {
        params: { page, per_page, ...filters },
    });
    return {
        data: response.data.data,
        pagination: response.data.pagination,
    };
}

export const addNewEmployee = async (formData: FormData) => {
    const response = await api.post(
        API_ROUTES.EMPLOYEE,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
    return response;
};

export const deleteEmployee = async (employeeId: number) => {
    const response = await api.delete(`${API_ROUTES.EMPLOYEE}/${employeeId}`);
    return response;
}

export const editEmployee = async (employeeId: number, edits: any) => {
    const response = await api.put(`${API_ROUTES.EMPLOYEE}/${employeeId}`, edits)
    return response;
}

export const toggleEmployeeStatus = async (employeeId: number) => {
    const response = await api.put(`${API_ROUTES.EMPLOYEE}/${employeeId}/toggle-status`);
    return response.data;
}

export const assignRoleToEmployee = async (tenantId: number, designationID: number, userId: number) => {
    const data = {
        tenant_id: tenantId,
        designation_id: designationID,
        user_id: userId
    }
    const response = await api.post(API_ROUTES.ASSIGN_ROLE_TO_EMPLOYEE, data)
    return response;
}

export const fetchUplineManager = async (tenantId: number, designationID: number, rank: number) => {
    const data = {
        "tenant_id": tenantId,
        "designation_id": designationID,
        "rank": rank
    }
    const response = await api.post(API_ROUTES.UPLINE_MANAGER, data);
    return response.data.data;
}


